import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { IsVisible } from '../../../utils';
import { FieldBase, IFieldBaseProps } from '../Base';
import { textFieldStyles } from './styles';

export interface ITextFieldProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'type'
  > {
  containerProps?: IFieldBaseProps;
  endAdornment?: React.ReactNode;
  startAdornment?: React.ReactNode;
  type?: 'text' | 'email';
}

export function TextField({
  className = '',
  containerProps,
  disabled = false,
  endAdornment,
  name,
  readOnly = false,
  startAdornment,
  type = 'text',
  ...rest
}: ITextFieldProps): JSX.Element {
  return (
    <FieldBase
      disabled={disabled || readOnly || containerProps?.disabled}
      {...containerProps}
    >
      <div className={textFieldStyles.container()}>
        <IsVisible when={!!startAdornment}>
          <span aria-hidden="true" className={textFieldStyles.startAdornment()}>
            {startAdornment}
          </span>
        </IsVisible>
        <input
          className={textFieldStyles.input({
            disabled: disabled || readOnly,
            className,
            startAdornment: !!startAdornment,
            endAdornment: !!endAdornment,
          })}
          disabled={disabled}
          name={name}
          readOnly={readOnly}
          type={type}
          {...rest}
        />
        <IsVisible when={!!endAdornment}>
          <span aria-hidden="true" className={textFieldStyles.endAdornment()}>
            {endAdornment}
          </span>
        </IsVisible>
      </div>
    </FieldBase>
  );
}
